import React from 'react';
import { Screen } from '../App';
import NavBar from '../components/NavBar';

interface Props { navigate: (s: Screen) => void; }

const features = [
  {
    emoji: '👨‍👩‍👧',
    title: 'Parent Bridge',
    desc: 'One tap generates a plain-language parent summary with home strategies that mirror what you are doing at school. Builds the home-school connection automatically.',
    eta: 'Coming soon'
  },
  {
    emoji: '📅',
    title: '90-Day Student Journey',
    desc: 'A guided 90-day arc for each student — week by week focus areas, progress milestones, and trajectory insights. The coaching methodology running on autopilot.',
    eta: 'Coming soon'
  },
  {
    emoji: '📬',
    title: 'Weekly Summary',
    desc: 'Every Sunday evening — a personalized in-app summary of your week. Which students made progress, which strategies are working, and what to focus on Monday morning.',
    eta: 'Coming soon'
  },
  {
    emoji: '🏫',
    title: 'School & District Plans',
    desc: 'Bring Decode My Student to your whole school or district. Shared student profiles, admin dashboards, and professional development integration.',
    eta: 'Contact us'
  },
  {
    emoji: '🎓',
    title: 'BHWC Certification',
    desc: 'Teachers who engage deeply with the app for 90 days can unlock a pathway to becoming a certified Brain Health Wellness Coach through We R H.O.P.E.',
    eta: 'Coming soon'
  },
  {
    emoji: '🌐',
    title: 'Parent Portal',
    desc: 'Parents can request access to their child\'s profile, contribute context, and collaborate with teachers through the AI on a unified support plan.',
    eta: 'Coming soon'
  },
];

export default function ComingSoon({ navigate }: Props) {
  return (
    <div>
      <div className="top-bar">
        <button onClick={() => navigate('dashboard')} style={{ background: 'none', color: 'var(--teal)', display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18"><polyline points="15,18 9,12 15,6" /></svg>Back
        </button>
        <span className="top-bar-logo" style={{ fontSize: 15 }}>What's Coming</span>
        <div style={{ width: 60 }} />
      </div>

      <div className="page-content">
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <p style={{ fontSize: 36, marginBottom: 12 }}>🚀</p>
          <h2 style={{ marginBottom: 8 }}>Decode My Student is just getting started.</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
            Here is what we are building next. Your feedback shapes what comes first.
          </p>
        </div>

        {features.map((f, i) => (
          <div key={i} className="card" style={{ marginBottom: 12, opacity: 0.95 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 24 }}>{f.emoji}</span>
                <p style={{ fontWeight: 700, fontSize: 15 }}>{f.title}</p>
              </div>
              <span style={{ background: f.eta === 'Contact us' ? 'var(--teal-light)' : 'var(--amber-light)', color: f.eta === 'Contact us' ? 'var(--teal)' : '#b87800', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', marginLeft: 8 }}>
                {f.eta}
              </span>
            </div>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6 }}>{f.desc}</p>
          </div>
        ))}

        <div style={{ background: 'var(--teal)', borderRadius: 14, padding: '24px', textAlign: 'center', marginTop: 8 }}>
          <p style={{ color: 'white', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Have a feature idea?</p>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, marginBottom: 16, lineHeight: 1.6 }}>
            Your ideas shape what we build next. Teachers who share feedback get early access to new features.
          </p>
          <a href="mailto:decodemystudent@gmail.com" style={{ background: 'white', color: 'var(--teal)', padding: '12px 24px', borderRadius: 10, fontSize: 14, fontWeight: 700, textDecoration: 'none', display: 'inline-block' }}>
            Share Your Ideas
          </a>
        </div>

        <div style={{ marginTop: 20, padding: '16px', background: 'var(--teal-light)', borderRadius: 12, textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--teal)', fontWeight: 600, marginBottom: 4 }}>🌟 We R H.O.P.E. Partnership</p>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            Decode My Student is built on the foundation of We R H.O.P.E. — the first school-embedded brain health coaching program in the United States.
          </p>
        </div>
      </div>
      <NavBar navigate={navigate} active="dashboard" />
    </div>
  );
}
